define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/TextProperty",
    "../properties/EditableProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/PlaceholderTextProperty",
    "../properties/ErrorTextProperty",
    "../properties/WarningTextProperty",
    "../properties/ValidationStateProperty"

], function (lang, TypeConstants, TypeProperty, TagProperty, TextProperty, EditableProperty, EnabledProperty,
             DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
             PlaceholderTextProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty) {
    var hash = {};

    hash[TypeConstants.TEXT_FIELD] = lang.mixin({}, {

        }, TypeProperty, TagProperty, TextProperty, EditableProperty, EnabledProperty, DescriptionProperty,
        DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
        PlaceholderTextProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty);

    return hash;
});

